import { PublicKey as SolanaPublicKey, Transaction, TransactionInstruction, } from '@solana/web3.js';
import { DIALECT_BLOCKCHAIN_SDK_TYPE_SOLANA } from '../../sdk/constants';
export const SOLANA_TX_TOKEN_SIGNER_ALG = `${DIALECT_BLOCKCHAIN_SDK_TYPE_SOLANA}-tx`;
export class SolanaTxTokenSigner {
    constructor() {
        this.alg = SOLANA_TX_TOKEN_SIGNER_ALG;
    }
}
export class DialectWalletAdapterSolanaTxTokenSigner extends SolanaTxTokenSigner {
    constructor(dialectWalletAdapter) {
        super();
        this.dialectWalletAdapter = dialectWalletAdapter;
    }
    get subject() {
        return this.dialectWalletAdapter.publicKey.toBase58();
    }
    get subjectPublicKey() {
        return this.dialectWalletAdapter.publicKey;
    }
    async sign(payload) {
        const tx = new Transaction();
        const subjectPublicKey = new SolanaPublicKey(this.subject);
        tx.add(new TransactionInstruction({
            keys: [
                {
                    pubkey: subjectPublicKey,
                    isSigner: false,
                    isWritable: false,
                },
            ],
            programId: subjectPublicKey,
            data: Buffer.from(payload),
        }));
        tx.recentBlockhash = SolanaPublicKey.default.toString();
        tx.feePayer = subjectPublicKey;
        const signedTx = await this.dialectWalletAdapter.signTransaction(tx);
        return {
            payload: signedTx.serialize(),
            signature: signedTx.signature,
        };
    }
}
//# sourceMappingURL=solana-tx-token-signer.js.map